export const DEFAULT_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const DEFAULT_DAY = 'YYYY-MM-DD';
